const CONTENT_DEFAULT = '<div>{{CompanyName}}</div><div>{{LastName}}様</div><div></div><div>{{SenderLastName}}と申します。</div><div></div><div></div><div></div>';

export {
  CONTENT_DEFAULT,
};
